/* eslint-disable better-tailwindcss/no-unknown-classes */
import React from 'react';

import { Text } from '@infinex/ui/components';

import { InfoImage } from './InfoImage';

import { smartTruncate } from '../utils/smartTruncate';

type UserInfoCardProps = {
  emblemSrc: string; // wallet/app emblem (e.g., InfinexIcon)
  walletLabel: string; // e.g., "Infinex Wallet" or account name
  walletAddress: string;
  chainKey?: string; // e.g., "ethereum"
  showOnlineDot?: boolean; // little green dot
  className?: string;
};

export function UserInfoCard({
  emblemSrc,
  walletLabel,
  walletAddress,
  chainKey = 'ethereum',
  showOnlineDot = false,
  className = '',
}: UserInfoCardProps) {
  return (
    <div className={`bg-surface rounded-b-3xl p-4 ${className} rounded-t-lg`}>
      <div className="flex items-center gap-4">
        <InfoImage
          src={emblemSrc}
          alt={walletLabel}
          chain={chainKey}
          className="rounded-xl"
          haloBg="#1C1E21"
          size={40}
          badgeSize={18}
          haloSize={1}
          emblemPosition="bottom-right"
        />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1">
            <Text className="text truncate text-sm font-semibold">
              {walletLabel}
            </Text>
          </div>
          <div className="mt-0.5 flex items-center gap-2">
            <span className="text-secondary font-regular text-sm">
              {smartTruncate(walletAddress, 16)}
            </span>
            {showOnlineDot && (
              <span
                className="text-positiveOnFill inline-block size-1.5 rounded-full bg-current"
                aria-hidden
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
